import axios from 'axios';

const HTTP = axios.create({
  headers: {
    'X-WP-Nonce': specialObj.nonce,
  },
});

export default HTTP;



// WEBPACK FOOTER //
// ./js/components/http.js